import { siteEvents } from '@/lib/siteEvents';

/**
 * Where the form sits on desktop, split test alert_place_v1 (from 2026-11-03).
 * From Oct 20 to Nov 3 the desktop sidebar card was seen by 7,084 visits and
 * signed up 5 (0.07%); the same form inline after the job summary, which
 * phones get, signed up 11 of 1,411 (0.8%), and 2 of 128 on narrow desktops.
 * Arm `rail` keeps the sidebar card on desktop; arm `inline` shows the inline
 * card on desktop too and hides the sidebar one (JobDetailPage adds
 * .jd-alert-place-inline to the page root). Phones see the inline card in both
 * arms. Every alert event carries `place`.
 */
export const ALERT_PLACE: 'rail' | 'inline' = siteEvents.arm('alert_place_v1') === 1 ? 'inline' : 'rail';
